import { Configuration, IConfiguration } from '@/models/configuration/Configuration';

export interface IDexieConfiguration extends IConfiguration {
    id?: number;
}

export class DexieConfiguration extends Configuration {
    public id?: number;

    constructor();
    // tslint:disable-next-line: unified-signatures
    constructor(obj: IDexieConfiguration);
    // tslint:disable-next-line: unified-signatures
    // constructor(obj: ConfigurationField | ConfigurationFieldNumber)
    constructor(obj?: any) {
        super(obj && obj as IConfiguration);
        this.id = obj && obj.id != null ? obj.id : undefined;
    }
}
